/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Open_ListingInputs */

const cs_pm_open_listing = /** @type {(inputs: Pm_Open_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít inzerát`)
};

const en_pm_open_listing = /** @type {(inputs: Pm_Open_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open listing`)
};

/**
* | output |
* | --- |
* | "Open listing" |
*
* @param {Pm_Open_ListingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_open_listing = /** @type {((inputs?: Pm_Open_ListingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Open_ListingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_open_listing(inputs)
	return cs_pm_open_listing(inputs)
});